import React, { useState } from "react";
import { Card, Upload, Button, Typography, message } from "antd";
import { UploadOutlined, FileTextOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";
import Sidebar from "../layout/sidebar";
import api from "../api/api";

const { Title, Text } = Typography;

const CargaCsvUsuarios = () => {
  const [fileList, setFileList] = useState([]);
  const [loading, setLoading] = useState(false);

  // Validar archivo antes de subir
  const beforeUpload = (file) => {
    const isCSV = file.type === "text/csv" || file.name.endsWith(".csv");

    if (!isCSV) {
      message.error("Solo puedes subir archivos CSV");
      return Upload.LIST_IGNORE;
    }

    setFileList([file]);
    return false;
  };

  const handleUpload = () => {
    if (fileList.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Atención",
        text: "Debes seleccionar un archivo CSV",
      });
      return;
    }

    const formData = new FormData();
    formData.append("file", fileList[0]);

    setLoading(true);

    let errorMostrado = false;

    // ⏱️ Mensaje si tarda más de 7 segundos
    const timer = setTimeout(() => {
      if (!errorMostrado) {
        Swal.fire({
          icon: "info",
          title: "Procesando solicitud",
          text: "Tu archivo se está procesando. Serás notificado vía correo electrónico.",
          confirmButtonColor: "#3085d6",
        });
      }
    }, 7000);

    // 🚀 Petición SIN await (no bloquea UI)
    api
      .post("/api/AdduserEbookEcommerceCsvAsync", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(() => {
        clearTimeout(timer);

        Swal.fire({
          icon: "success",
          title: "Solicitud enviada",
          text: "El archivo fue enviado correctamente. Recibirás un correo con el resultado.",
          confirmButtonColor: "#3085d6",
        });

        setFileList([]);
      })
      .catch((error) => {
        clearTimeout(timer);
        errorMostrado = true;

        Swal.fire({
          icon: "error",
          title: "Error en el archivo",
          text:
            error.response?.data?.message ||
            "El archivo tiene un formato inválido o ocurrió un error al procesarlo.",
        });
      })
      .finally(() => {
        setLoading(false); // ✅ Nunca se queda cargando
      });
  };

  return (
    <Card
      style={{
        maxWidth: 600,
        margin: "0 auto",
        borderRadius: 12,
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      }}
    >
      <Sidebar />

      <Title level={3}>Carga de Usuarios CSV</Title>
      <Text type="secondary">
        Sube un archivo CSV para registrar usuarios en el sistema
      </Text>

      <div style={{ marginTop: 20 }}>
        <Upload
          beforeUpload={beforeUpload}
          fileList={fileList}
          onRemove={() => setFileList([])}
          maxCount={1}
        >
          <Button icon={<UploadOutlined />}>Seleccionar archivo CSV</Button>
        </Upload>
      </div>

      {fileList.length > 0 && (
        <div style={{ marginTop: 15 }}>
          <Text strong>
            <FileTextOutlined /> Archivo seleccionado:
          </Text>
          <br />
          <Text>{fileList[0].name}</Text>
        </div>
      )}

      <Button
        type="primary"
        onClick={handleUpload}
        loading={loading}
        style={{
          marginTop: 20,
          width: "100%",
          height: 40,
          borderRadius: 8,
        }}
      >
        {loading ? "Cargando..." : "Subir archivo"}
      </Button>
    </Card>
  );
};

export default CargaCsvUsuarios;
